import { create } from 'zustand';


export interface LocatingFilterState {
  searchTerm: string;
  searchChips: { text: string; tagType: string }[];
  selectedTagType: string;
  asOfDate: string | null;
  originalAsOfDate: string | null | undefined;
  locatingMode: 'asOf' | 'range';
  currentTime: number;
  rangeStartDate: string | null;
  rangeEndDate: string | null;
  showAllActivity: boolean;
}

export const initialLocatingFilterState: LocatingFilterState = {
  searchTerm: '',
  searchChips: [],
  selectedTagType: 'all',
  asOfDate: null,
  originalAsOfDate: undefined,
  locatingMode: 'asOf',
  currentTime: 100,
  rangeStartDate: null,
  rangeEndDate: null,
  showAllActivity: false,
};

export interface LocatingFilterStore {
  filterState: LocatingFilterState;
  update: (partial: Partial<LocatingFilterState>) => void;
  clear: () => void;
}

export const useLocatingFilterStore = create<LocatingFilterStore>(
  (set, get) => ({
    filterState: initialLocatingFilterState,
    update: (partial) =>
      set({ filterState: { ...get().filterState, ...partial } }),
    clear: () =>
      set({
        filterState: {
          ...get().filterState,
          searchTerm: '',
          searchChips: [],
          selectedTagType: 'all',
          asOfDate: null,
          locatingMode: 'asOf',
          showAllActivity: false,
        },
      }),
  })
);
